/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/baseClasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.MembershipCancellation {
    "use strict";

    export class MembershipCancellationContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $scope: ng.IScope) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.membershipCancellation;
            this.sectionTemplatePath = "app/plugins/membershipCancellation/sectionViews/";

            this.buildCrudSecurityKeys(this.securityKeys.MEMBERSHIP_CANCELLATIONREASON_TAB_MAIN);
            this.entityType = 'MembershipCancellationReason';
            this.$scope.$watch( ()=> {
                this.isLoading ? this.busyService.start() : this.busyService.stop();
            });
        }

        initializeSections(): void {
          if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_CANCELLATIONREASON_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_MEMBERSHIP_CANCELLATION_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.membershipCancellation, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.MembershipCancellationReasonMain, null, this.securityKeys.MEMBERSHIP_CANCELLATIONREASON_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
           }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        postCopy(): void {
            super.postCopy();

            this.selectedSection.model['displayName'] = '';
        }

    }
}